<template>
  <div class="changelog-entry">
    <div
      class="changelog-entry__action"
      :class="viewData.actionClass"
    >
      <i
        class="fa changelog-entry__action-icon"
        :class="{
          'fa-plus-circle': viewData.actionText === 'created',
          'fa-pencil': viewData.actionText === 'updated',
          'fa-minus-circle': viewData.actionText === 'deleted', 
        }"
      />
    </div>

    <div class="changelog-entry__summary">
      <slot>
        <div
          class="changelog-entry__info"
          v-html="statement"
        />
      </slot>

      <div
        class="changelog-entry__date"
        v-text="shortTime"
      />
    </div>
  </div>
</template>

<script>
import messages from './locales';
import moment from 'moment';

import { getActionViewData, getActionStatement } from './changelog-helpers';

export default {
  name: 'ChangeLogEntry',
  props:{
    changelog: {
      type: Object,
      required: true,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    viewData() {
      return getActionViewData(this.changelog);
    },
    statement() {
      return getActionStatement(this.changelog);
    },
    shortTime() {
      return moment(String(this.changelog.dtStamp)).format('hh:mmA');
    }
  },
  i18n: {
    messages,
    locale: 'en',
  }
};
</script>
